<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adc01">
<a id="pageiii"></a>
<h2 class="adCardHead"><span class="bold">Also by Michael Parness</span></h2>
<p class="adCardText"><em class="italic">Rule the Freakin’ Markets</em></p>
<p class="adCardText"><em class="italic">Power Trading/Power Living</em></p>
<a id="pageiv"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_adc01.vue?f6979b2a